import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/PreAdvise/Placards.css';
import uncheckedimg from '../../../Assets/TruckVisits/Assets-Desktop/unchecked-box.svg';
import checked from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox-checked.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class Placards extends Component {
    constructor(props) {
        super(props)
        this.state = {
            placardsdata: [
                { id: 1, sequenceNo: "1.1", name: "Corrosives" },
                { id: 2, sequenceNo: "2.1", name: "Dangerous When Wet" },
                { id: 3, sequenceNo: "2.2", name: "Explosives" },
                { id: 4, sequenceNo: "2.3", name: "Flammable Gases" },
                { id: 5, sequenceNo: "2.4", name: "Flammable Liquids" },
                { id: 6, sequenceNo: "4.1", name: "Flammable Solids" },
                { id: 7, sequenceNo: "4.3", name: "No-flammable Gases" },
                { id: 8, sequenceNo: "5.1", name: "Other Dangerous Materials" },
                { id: 9, sequenceNo: "6.1", name: "Oxidizing Agents" },
                { id: 10, sequenceNo: "7", name: "Radioactive Materials" },
                { id: 11, sequenceNo: "8", name: "Toxic Gases" },
                { id: 12, sequenceNo: "9", name: "Toxic Substances" }],
            placardSelectStatus: [],
            selectAll: false,
            checked: false
        }
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.placardsPageTitle} description={TitleDescription.placardsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullPlacards">
                    <div id="csnobox1Placards">
                        <nav class="ccnononavbar">
                            <div className="ccnonavbarnameplacard">
                                <small id="nonavc"> Set Placards</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="headingplacard">
                            <small id="headingsmall"> Click on the checkbox to include</small>
                        </div>
                        <div class="placardmaincard">
                            <div class="selectouterdiv">
                                <div class="selectleft">
                                    <div class="innerselectdiv">
                                        <small id="uncheckside">
                                            <img
                                                src={this.state.selectAll ?
                                                    checked :
                                                    uncheckedimg
                                                }
                                                width="20"
                                                height="20"
                                                id="placarduncheckimg"
                                                onClick={() => {
                                                    let a = this.state.placardsdata;
                                                    a = a.map(x => !this.state.selectAll);
                                                    this.setState({ placardSelectStatus: a, selectAll: !this.state.selectAll });
                                                    this.setState({ checked: true })
                                                }
                                                }
                                            />
                                        </small>
                                    </div>
                                </div>
                                <div class="selectright">
                                    <div class="innerselectall">
                                        <small id="selectall">Select All</small>
                                    </div>
                                </div>
                            </div>
                            {(this.state.placardsdata?.map((placardsdata1, index) => {
                                return (
                                    <div class="bottomallvaluescard">
                                        <div class="bottomcheck">
                                            <div class="innerdowndiv">
                                                <small id="uncheckside">
                                                    <img
                                                        src={this.state.placardSelectStatus[index] ?
                                                            checked :
                                                            uncheckedimg
                                                        }
                                                        width="20"
                                                        height="20"
                                                        id="placarduncheckimg"
                                                        onClick={() => {
                                                            let a = this.state.placardSelectStatus;
                                                            a[index] = !this.state.placardSelectStatus[index];
                                                            this.setState({ selectAll: false, placardSelectStatus: a });
                                                            this.setState({ checked: true })
                                                        }}
                                                    />
                                                </small>
                                            </div>
                                        </div>
                                        <div class="rightplacardvaluediv" >
                                            <div class="rightinnerdiv">
                                                <div class="lowsequencediv">
                                                    <small id="lowsequencevalue">{placardsdata1?.id}</small>
                                                </div>
                                                <div class="lowdatavaluediv">
                                                    <small id="lowdatavalue">{placardsdata1?.name}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>);
                            }))}
                            <div class="blankdiv"></div>
                        </div>
                        <div class="okbttnplacard">
                            <div class="btttndivv">
                                <Button class="bttplacard" onClick={this.submitContainer}>
                                    <small id="placardok"> OK</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default Placards;